import { Title } from './Title';
export function LabelHeading(props) {
    return <Title appearance="label" as="h4" {...props}/>;
}
